export default function numberFormat(number?: number | string) {
	if (!number) return number;

	return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
